<template>
  <!-- eslint-disable max-len -->
  <div
    class="configuration-wizard-first-things-first"
    :class="{'relative' : isBusy}"
  >
    <mj-spinner
      v-if="isBusy"
      :size="200"
      :class="{'absolute w-full h-full flex-col items-center bg-white-transparent' : isBusy}"
    >
      <div class="text-2xl font-semibold">
        Authorisierung läuft...
      </div>
    </mj-spinner>
    <mj-configuratin-wizard-header>
      <template #headline>
        First-things-first
      </template>
      <template #info-text>
        Du bist nur noch wenige Schritte davon entfernt den Playlist Manager im vollen Umfang zu nutzen.
        In nur 3 Schritten führen wir eine einmalige Konfiguration durch und schon kann es los gehen.
      </template>
      <template #progress-bar>
        <mj-configuratin-wizard-progress-bar
          :current-step="1"
          :labels="progressLabels"
        />
      </template>
    </mj-configuratin-wizard-header>
    <mj-configuratin-wizard-content class="flex flex-col md:flex-row">
      <div class="configuration-wizard-cta mb-16 w-full text-center md:mb-0 md:w-1/2 md:text-left">
        <h2 class="mb-12 font-semibold text-2xl">
          Verknüpfe die Moment-Juke mit Spotify
        </h2>
        <a :href="authorizeSpotify">
          <mj-button
            class="btn-primary"
          >
            Spotify autorisieren
          </mj-button>
        </a>
      </div>
      <div class="configuration-wizard-illustration w-full md:w-1/2">
        <mj-icon
          src="authentication"
          class="w-full h-auto"
          proportions="rectangle"
        />
      </div>
    </mj-configuratin-wizard-content>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getSpotifyLoginURI } from '@/helpers/index';
import ConfigurationWizardHeader from '@/components/configuration-wizard/ConfigurationWizardHeader.vue';
import ConfigurationWizardContent from '@/components/configuration-wizard/ConfigurationWizardContent.vue';
import ConfigurationWizardProgressBar from '@/components/configuration-wizard/ConfigurationWizardProgressBar.vue';

export default {
  name: 'ConfigurationWizardFirstThingsFirst',

  components: {
    'mj-configuratin-wizard-header': ConfigurationWizardHeader,
    'mj-configuratin-wizard-content': ConfigurationWizardContent,
    'mj-configuratin-wizard-progress-bar': ConfigurationWizardProgressBar,
  },

  data() {
    return {
      progressLabels: [
        { name: '1. Spotify autorisieren', isActive: true, isComplete: false },
        { name: '2. Event erstellen', isActive: false, isComplete: false },
        { name: '3. Los gehts', isActive: false, isComplete: false },
      ],
      isBusy: false,
    };
  },

  computed: {
    authorizeSpotify() {
      return getSpotifyLoginURI();
    },
  },

  methods: {
    ...mapActions(['authorizeSpotifyUser']),
  },

  created() {
    const { code } = this.$route.query;
    if (code) {
      this.isBusy = true;
      this.authorizeSpotifyUser({ code, redirectUri: process.env.VUE_APP_SPOTIFY_REDIRECT })
        .then(() => {
          this.$router.push({ name: 'configuration.wizard.create.event' });
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.isBusy = false;
        });
    }
  },
};

</script>

<style lang="scss" scoped>

.configuration-wizard {

  &-illustration {
    max-width: 35rem;
  }
}

  .bg-white-transparent {
    background-color: rgba(255, 255, 255, .9);
  }
</style>
